// Auto sumit form on visit
document.addEventListener('turbo:load', () => {
  const autosubmitForms = document.querySelectorAll('.js-auto-submit-on-visit');

  autosubmitForms.forEach(f => {
    // Because f can be a button or a form (e.g. button_to helper)
    const form = f.closest('form');
    form.requestSubmit();

    // Be nice to browser and Turbo cache and defer removal to next tick
    setTimeout(() => {
      f.remove();
      Turbo.cache.clear();
    }, 0);
  });
});
